"use client";

// packages/react/focus-scope/src/FocusScope.tsx
import _toConsumableArray from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _defineProperty from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _slicedToArray from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _objectWithoutProperties from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["loop", "trapped", "onMountAutoFocus", "onUnmountAutoFocus"];
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
import * as React from "react";
import { useComposedRefs } from "@radix-ui/react-compose-refs";
import { Primitive } from "@radix-ui/react-primitive";
import { useCallbackRef } from "@radix-ui/react-use-callback-ref";
import { jsx } from "react/jsx-runtime";
var AUTOFOCUS_ON_MOUNT = "focusScope.autoFocusOnMount";
var AUTOFOCUS_ON_UNMOUNT = "focusScope.autoFocusOnUnmount";
var EVENT_OPTIONS = {
  bubbles: false,
  cancelable: true
};
var FOCUS_SCOPE_NAME = "FocusScope";
var FocusScope = React.forwardRef(function (props, forwardedRef) {
  var _props$loop = props.loop,
    loop = _props$loop === void 0 ? false : _props$loop,
    _props$trapped = props.trapped,
    trapped = _props$trapped === void 0 ? false : _props$trapped,
    onMountAutoFocusProp = props.onMountAutoFocus,
    onUnmountAutoFocusProp = props.onUnmountAutoFocus,
    scopeProps = _objectWithoutProperties(props, _excluded);
  var _React$useState = React.useState(null),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    container = _React$useState2[0],
    setContainer = _React$useState2[1];
  var onMountAutoFocus = useCallbackRef(onMountAutoFocusProp);
  var onUnmountAutoFocus = useCallbackRef(onUnmountAutoFocusProp);
  var lastFocusedElementRef = React.useRef(null);
  var composedRefs = useComposedRefs(forwardedRef, function (node) {
    return setContainer(node);
  });
  var focusScope = React.useRef({
    paused: false,
    pause: function pause() {
      this.paused = true;
    },
    resume: function resume() {
      this.paused = false;
    }
  }).current;
  React.useEffect(function () {
    if (trapped) {
      var handleFocusIn2 = function handleFocusIn2(event) {
          if (focusScope.paused || !container) return;
          var target = event.target;
          if (container.contains(target)) {
            lastFocusedElementRef.current = target;
          } else {
            focus(lastFocusedElementRef.current, {
              select: true
            });
          }
        },
        handleFocusOut2 = function handleFocusOut2(event) {
          if (focusScope.paused || !container) return;
          var relatedTarget = event.relatedTarget;
          if (relatedTarget === null) return;
          if (!container.contains(relatedTarget)) {
            focus(lastFocusedElementRef.current, {
              select: true
            });
          }
        },
        handleMutations2 = function handleMutations2(mutations) {
          var focusedElement = document.activeElement;
          if (focusedElement !== document.body) return;
          var _iterator = _createForOfIteratorHelper(mutations),
            _step;
          try {
            for (_iterator.s(); !(_step = _iterator.n()).done;) {
              var mutation = _step.value;
              if (mutation.removedNodes.length > 0) focus(container);
            }
          } catch (err) {
            _iterator.e(err);
          } finally {
            _iterator.f();
          }
        };
      var handleFocusIn = handleFocusIn2,
        handleFocusOut = handleFocusOut2,
        handleMutations = handleMutations2;
      document.addEventListener("focusin", handleFocusIn2);
      document.addEventListener("focusout", handleFocusOut2);
      var mutationObserver = new MutationObserver(handleMutations2);
      if (container) mutationObserver.observe(container, {
        childList: true,
        subtree: true
      });
      return function () {
        document.removeEventListener("focusin", handleFocusIn2);
        document.removeEventListener("focusout", handleFocusOut2);
        mutationObserver.disconnect();
      };
    }
  }, [trapped, container, focusScope.paused]);
  React.useEffect(function () {
    if (container) {
      focusScopesStack.add(focusScope);
      var previouslyFocusedElement = document.activeElement;
      var hasFocusedCandidate = container.contains(previouslyFocusedElement);
      if (!hasFocusedCandidate) {
        var mountEvent = new CustomEvent(AUTOFOCUS_ON_MOUNT, EVENT_OPTIONS);
        container.addEventListener(AUTOFOCUS_ON_MOUNT, onMountAutoFocus);
        container.dispatchEvent(mountEvent);
        if (!mountEvent.defaultPrevented) {
          focusFirst(removeLinks(getTabbableCandidates(container)), {
            select: true
          });
          if (document.activeElement === previouslyFocusedElement) {
            focus(container);
          }
        }
      }
      return function () {
        container.removeEventListener(AUTOFOCUS_ON_MOUNT, onMountAutoFocus);
        setTimeout(function () {
          var unmountEvent = new CustomEvent(AUTOFOCUS_ON_UNMOUNT, EVENT_OPTIONS);
          container.addEventListener(AUTOFOCUS_ON_UNMOUNT, onUnmountAutoFocus);
          container.dispatchEvent(unmountEvent);
          if (!unmountEvent.defaultPrevented) {
            focus(previouslyFocusedElement !== null && previouslyFocusedElement !== void 0 ? previouslyFocusedElement : document.body, {
              select: true
            });
          }
          container.removeEventListener(AUTOFOCUS_ON_UNMOUNT, onUnmountAutoFocus);
          focusScopesStack.remove(focusScope);
        }, 0);
      };
    }
  }, [container, onMountAutoFocus, onUnmountAutoFocus, focusScope]);
  var handleKeyDown = React.useCallback(function (event) {
    if (!loop && !trapped) return;
    if (focusScope.paused) return;
    var isTabKey = event.key === "Tab" && !event.altKey && !event.ctrlKey && !event.metaKey;
    var focusedElement = document.activeElement;
    if (isTabKey && focusedElement) {
      var container2 = event.currentTarget;
      var _getTabbableEdges = getTabbableEdges(container2),
        _getTabbableEdges2 = _slicedToArray(_getTabbableEdges, 2),
        first = _getTabbableEdges2[0],
        last = _getTabbableEdges2[1];
      var hasTabbableElementsInside = first && last;
      if (!hasTabbableElementsInside) {
        if (focusedElement === container2) event.preventDefault();
      } else {
        if (!event.shiftKey && focusedElement === last) {
          event.preventDefault();
          if (loop) focus(first, {
            select: true
          });
        } else if (event.shiftKey && focusedElement === first) {
          event.preventDefault();
          if (loop) focus(last, {
            select: true
          });
        }
      }
    }
  }, [loop, trapped, focusScope.paused]);
  return /* @__PURE__ */jsx(Primitive.div, _objectSpread(_objectSpread({
    tabIndex: -1
  }, scopeProps), {}, {
    ref: composedRefs,
    onKeyDown: handleKeyDown
  }));
});
FocusScope.displayName = FOCUS_SCOPE_NAME;
function focusFirst(candidates) {
  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
    _ref$select = _ref.select,
    select = _ref$select === void 0 ? false : _ref$select;
  var previouslyFocusedElement = document.activeElement;
  var _iterator2 = _createForOfIteratorHelper(candidates),
    _step2;
  try {
    for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
      var candidate = _step2.value;
      focus(candidate, {
        select: select
      });
      if (document.activeElement !== previouslyFocusedElement) return;
    }
  } catch (err) {
    _iterator2.e(err);
  } finally {
    _iterator2.f();
  }
}
function getTabbableEdges(container) {
  var candidates = getTabbableCandidates(container);
  var first = findVisible(candidates, container);
  var last = findVisible(candidates.reverse(), container);
  return [first, last];
}
function getTabbableCandidates(container) {
  var nodes = [];
  var walker = document.createTreeWalker(container, NodeFilter.SHOW_ELEMENT, {
    acceptNode: function acceptNode(node) {
      var isHiddenInput = node.tagName === "INPUT" && node.type === "hidden";
      if (node.disabled || node.hidden || isHiddenInput) return NodeFilter.FILTER_SKIP;
      return node.tabIndex >= 0 ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
    }
  });
  while (walker.nextNode()) {
    nodes.push(walker.currentNode);
  }
  return nodes;
}
function findVisible(elements, container) {
  var _iterator3 = _createForOfIteratorHelper(elements),
    _step3;
  try {
    for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
      var element = _step3.value;
      if (!isHidden(element, {
        upTo: container
      })) return element;
    }
  } catch (err) {
    _iterator3.e(err);
  } finally {
    _iterator3.f();
  }
}
function isHidden(node, _ref2) {
  var upTo = _ref2.upTo;
  if (getComputedStyle(node).visibility === "hidden") return true;
  while (node) {
    if (upTo !== void 0 && node === upTo) return false;
    if (getComputedStyle(node).display === "none") return true;
    node = node.parentElement;
  }
  return false;
}
function isSelectableInput(element) {
  return element instanceof HTMLInputElement && "select" in element;
}
function focus(element) {
  var _ref3 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
    _ref3$select = _ref3.select,
    select = _ref3$select === void 0 ? false : _ref3$select;
  if (element && element.focus) {
    var previouslyFocusedElement = document.activeElement;
    element.focus({
      preventScroll: true
    });
    if (element !== previouslyFocusedElement && isSelectableInput(element) && select) element.select();
  }
}
var focusScopesStack = createFocusScopesStack();
function createFocusScopesStack() {
  var stack = [];
  return {
    add: function add(focusScope) {
      var activeFocusScope = stack[0];
      if (focusScope !== activeFocusScope) {
        activeFocusScope === null || activeFocusScope === void 0 ? void 0 : activeFocusScope.pause();
      }
      stack = arrayRemove(stack, focusScope);
      stack.unshift(focusScope);
    },
    remove: function remove(focusScope) {
      var _stack$;
      stack = arrayRemove(stack, focusScope);
      (_stack$ = stack[0]) === null || _stack$ === void 0 ? void 0 : _stack$.resume();
    }
  };
}
function arrayRemove(array, item) {
  var updatedArray = _toConsumableArray(array);
  var index = updatedArray.indexOf(item);
  if (index !== -1) {
    updatedArray.splice(index, 1);
  }
  return updatedArray;
}
function removeLinks(items) {
  return items.filter(function (item) {
    return item.tagName !== "A";
  });
}
var Root = FocusScope;
export { FocusScope, Root };